import { POST } from './api'

export const SubmitBrazilEvent = async (payload) => (
    await POST('/integrations/brazil-event', payload)
)
